/*
 * Free-delivery bar: animates the fill and the truck after a cart re-render.
 *
 * Cart updates REPLACE the bar's markup (drawer innerHTML, cart-drawer-items,
 * .js-contents), so a CSS transition has nothing to transition from. We keep
 * the last progress per bar in memory, and on a fresh element set --hy-fsb-p
 * to the OLD value, force a reflow, then set the new one.
 *
 * An add-to-cart rebuilds the drawer TWICE: renderContents() replaces
 * #CartDrawer at once, then the cartUpdate fetch resolves 150-400ms later and
 * replaces cart-drawer-items with a second bar carrying the same value. The
 * second render must not cancel the motion, so each bar's running animation is
 * remembered in `inflight` and the new element continues from where the first
 * one has got to.
 *
 * Progressive enhancement: the server-rendered state is already correct.
 * First paint and "open the drawer from the header" never animate.
 */
(function () {
  if (window.hyFreeShippingBar) return;
  window.hyFreeShippingBar = true;

  var PROP = '--hy-fsb-p';
  var DUR_PROP = '--hy-fsb-dur';
  var REACHED = 'hy-fsb--reached';
  var DURATION = 700;
  var HOUSE_FADE = 300;
  var OPEN_DELAY = 250; // let the drawer slide in before the motion starts
  var last = {};
  var inflight = {};
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function read(el) {
    var v = parseFloat(el.style.getPropertyValue(PROP));
    return isNaN(v) ? null : v;
  }

  // Where a running animation has got to (ease-out approximation).
  function positionAt(f, now) {
    if (now <= f.start) return f.from;
    var t = Math.min(1, (now - f.start) / f.dur);
    return f.from + (f.to - f.from) * (1 - Math.pow(1 - t, 3));
  }

  function animate(ctx, el, from, to, delay, dur, replayHouse) {
    var arriving = replayHouse && el.classList.contains(REACHED) && from < 1;
    var f = { from: from, to: to, start: performance.now() + delay, dur: dur };
    inflight[ctx] = f;

    el.style.setProperty(DUR_PROP, dur + 'ms');
    el.style.setProperty(PROP, from);
    if (arriving) el.classList.remove(REACHED);
    void el.offsetWidth; // commit the starting point

    var go = function () {
      if (!el.isConnected) return;
      el.style.setProperty(PROP, to);
      if (arriving) el.classList.add(REACHED);
    };
    if (delay > 0) setTimeout(go, delay);
    else go();
    setTimeout(function () {
      if (inflight[ctx] === f) delete inflight[ctx];
    }, delay + dur + 50);
  }

  function scan(initial) {
    var seen = {};
    var bars = document.querySelectorAll('.hy-fsb[data-hy-fsb]');
    for (var i = 0; i < bars.length; i++) {
      var el = bars[i];
      var ctx = el.getAttribute('data-hy-fsb');
      seen[ctx] = true;
      if (el.hasAttribute('data-hy-fsb-ready')) continue;
      el.setAttribute('data-hy-fsb-ready', '');
      var p = read(el);
      if (p === null) continue;
      var prev = last[ctx];
      last[ctx] = p;
      if (initial || (reduced && reduced.matches) || prev === undefined) continue;

      var now = performance.now();
      var f = inflight[ctx];
      var running = f && now < f.start + f.dur;

      if (prev === p) {
        // Same value again: a second render of the same update. Carry on.
        if (!running || f.to !== p) continue;
        if (now < f.start) {
          animate(ctx, el, f.from, p, f.start - now, f.dur, true); // delay still pending
        } else {
          var elapsed = now - f.start;
          // Past the house fade, the check is already showing: don't replay it.
          animate(ctx, el, positionAt(f, now), p, 0, Math.max(100, f.dur - elapsed), elapsed < HOUSE_FADE);
        }
        continue;
      }

      // A new value. If the bar is still moving, start from where it is.
      var from = running ? positionAt(f, now) : prev;
      var drawer = el.closest('cart-drawer');
      var delay = drawer && !drawer.classList.contains('active') ? OPEN_DELAY : 0;
      animate(ctx, el, from, p, delay, DURATION, true);
    }
    // No bar (empty cart): the next one grows from the start.
    ['drawer', 'page'].forEach(function (ctx) {
      if (!seen[ctx]) {
        last[ctx] = 0;
        delete inflight[ctx];
      }
    });
  }

  function init() {
    scan(true);
    var observer = new MutationObserver(function () {
      scan(false);
    });
    var roots = document.querySelectorAll('cart-drawer, cart-items');
    for (var i = 0; i < roots.length; i++) observer.observe(roots[i], { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
